import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import weChatPrefab from "../../../spendMode/prefab/weChatPrefab/weChatPrefab";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { backpackUseRuleI } from "../../config/backpackConst";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { getOneHeadUrlById } from "../../config/UserHeadConfig";
import { getOnePeopleById } from "../../config/WeChatPeopleConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatLink, WeChatSaveChat, WeChatManagerPeople, WeChatChitChat } from "../../manager/WeChatConst";
import backpackOpenBase from "../backpackOpenBase";
import WeChatFrame from "./WeChatFrame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WeChatFrameByAuction extends backpackOpenBase {
    onBackPackOpenPrefab(useRule:backpackUseRuleI,complete?:(isSell:boolean)=>void) {
        this.useRule = useRule;
        let backpackItemId = useRule.backId;
        let backPackItem = backPackEventMap()[backpackItemId];
        this.bindData(backPackItem.name, Math.floor( NormalGameManager._instance.getPriceRate() * backPackItem.sellPrice ),complete);
    }

    @property({type:cc.Prefab,displayName:"自己说话预制体"})
    meAskPrefab:cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"其他说话预制体"})
    otherAskPrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Node,displayName:"选项节点"})
    chooseNode:cc.Node = null;

    @property({type:cc.Node,displayName:""})
    resultNode:cc.Node = null;

    @property({type:cc.ScrollView,displayName:"滚动条"})
    chatScroll:cc.ScrollView = null;

    initNpcs:string[] = [
        "勾东强",
        "刷侯军",
        "夕夕峥",
        "焯系腾",
        "该次比",
        "斯科马",
        "川建国",
    ];

    npcInitChats:string[] = [
        "一口价$元",
        "$元，小兄弟，如果你卖给我，我们可以开展更多的合作",
        "哇！绝世珍品，我出$元",
        "人狠话不多，我出$元",
        "以和为贵，我就小小的出个$元",
        "各位大佬,我要送给情人，就让给我吧，我出$元",
        "不说废话我直接出$元拿下",
        "$元！！！！"
    ]

    meStartChats:string[] = [
        "刚刚开出的极品【~】",
        "各位大佬有没有兴趣"
    ]

    meOtherChats:string[]= [
        "成交",
        "不卖"
    ]

    useRule:backpackUseRuleI = null;

    endChat:string = "算了,我还是不卖了！";

    objName:string = "未知物品";
    price:number = 300000;

    currentPrice:number = null;
    currentNpc:string = null;

    npcs:string[] = [];
    npcChats:string[] = [];

    currentChooseAry:string[] = [];

    spriteMap:{[id:string]:cc.SpriteFrame} = {};

    isSell:boolean = false;

    showPriceCount:number = 0;

    async start(){
        await this.loadSprites();
        this.startChat();
    }

    //获取一个随机的npc
    getRandNpc(){
        this.npcs = data_control.randomSortArray(this.npcs);
        let chatNpc = this.npcs.pop();
        this.currentNpc = chatNpc;
        return chatNpc;
    }

    //获取一个随机的npc说的话
    getRandNpcChat(){
        this.npcChats = data_control.randomSortArray(this.npcChats)
        let otherChat:string = this.npcChats.pop();
        return otherChat;
    }
    //获取随机的区间的钱
    setRandMoney(){
        let num = data_control.getRandNumberOfArrayTwo(gameConfig.BOSS_VALUATION_RATIO);
        this.currentPrice = Math.floor(this.price * num);
    }

    async loadSprites(){
        return new Promise<void>(resolve=>{
            let meHead = "res/user/head/" + getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
            O1HD.getManagers().gameMgr.getCurrMode().bundle.load(meHead,cc.SpriteFrame,(err,imgs:cc.SpriteFrame)=>{
                if(err){
                    console.log(err);
                }else{
                    this.spriteMap[meHead] = imgs;
                }
            });
            let imgUrls:string[] = [];

            for(let npc of this.initNpcs){
                let people = getOnePeopleById(npc);
                let url = people.headUrl;
                if(!imgUrls.includes(url)){
                    imgUrls.push(url);
                }
            }
            // console.log(imgUrls);
            if(imgUrls.length > 0){
                getOneBundleByInstant(BUNDLE_SMALL_NAME.WeChatGameBundle).load(imgUrls,cc.SpriteFrame,(err,imgs:cc.SpriteFrame[])=>{
                    if(err){
                        console.log(err);
                    }else{
                        for(let i =0;i<imgs.length;i++){
                            this.spriteMap[imgUrls[i]] = imgs[i];
                        }
                        // console.log(this.spriteMap);
                    }
                    resolve();
                });
            }else{
                resolve();
            }
        });
    }

    complete?:(isSell:boolean)=>void = null;

    /**
     * @param objName 物品名字
     * @param price 物品价格
     */
    bindData(objName:string,price:number,complete?:(isSell:boolean)=>void){
        this.objName = objName;
        this.price = Math.floor( NormalGameManager._instance.getPriceRate() * price );
        this.complete = complete;
    }

    startChat(){
        this.showPriceCount = 0;
        this.npcChats = this.npcInitChats.concat();
        this.npcs = this.initNpcs.concat();
        this.itemContent.destroyAllChildren();
        this.itemContent.removeAllChildren();
        this.scheduleOnce(()=>{
            for(let i = 0;i<this.meStartChats.length;i++){
                let str = this.meStartChats[i];
                str = str.replace("~",this.objName);
                let node:cc.Node = cc.instantiate(this.meAskPrefab);
                let ns = node.getComponent(weChatPrefab);
                let meHead = "res/user/head/" + getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
                ns.changeHead(this.spriteMap[meHead]);
                ns.setChat(str);
                node.setParent(this.itemContent);
                this.chatScroll.scrollToBottom(.2);
            }
            let otherChat = this.getRandNpcChat();
            let chatNpc = this.getRandNpc();
            this.setRandMoney();
            this.onChat(otherChat,chatNpc);
        });
    }

    onChat(chatStr:string,chatNpc?:string){
        switch(chatNpc){
            case "自己":{
                // 自己说话
                this.onMeChat(chatStr);
                break;
            }
            default:{
                // 其他人说话
                this.onOtherChat(chatStr,chatNpc)
                break;
            }
        }
    }

    onMeChat(chat:string){
        let chatItem:cc.Node = cc.instantiate(this.meAskPrefab);
        let cs = chatItem.getComponent(weChatPrefab);
        let meHead = "res/user/head/" + getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
        cs.changeHead(this.spriteMap[meHead]);
        cs.setChat(chat);
        chatItem.setParent(this.itemContent);
        this.chatScroll.scrollToBottom(.2);
        if(chat == "成交"){
            // 成交
            this.scheduleOnce(this.onMeComplete,.5);
        }else if(chat == this.endChat) {
            // 不卖了
            if(!this.isSell){
                this.complete && this.complete(false );
                this.closeThis();
            }
        }else{
            //继续聊天剧情
            if(this.showPriceCount < 5){
                let randChat = this.getRandNpcChat();
                let randNpc = this.getRandNpc();
                this.setRandMoney();
                this.scheduleOnce(()=>{
                    this.onChat(randChat,randNpc);
                },.5);
                this.showPriceCount ++;
            }else{
                this.showResult();
            }
        }
    }

    onOtherChat(chat:string,npcName:string){
        chat = chat.replace("$",data_control.getNumberFormat(this.currentPrice));
        let chatItem:cc.Node = cc.instantiate(this.otherAskPrefab);
        let cs = chatItem.getComponent(weChatPrefab);
        cs.onChat(chat,false);
        chatItem.setParent(this.itemContent);
        this.chatScroll.scrollToBottom(.2);
        let people = getOnePeopleById(npcName);
        let headSp = this.spriteMap[people.headUrl];
        // console.log(this.spriteMap,"zmhuis")
        cs.changeHead(headSp);
        if(chat.includes("红包：")){
            cs.setRedPacketFun(()=>{
                // 领取了红包  直接关闭当前界面
                this.isSell = true;
                this.complete && this.complete(true);
                this.closeThis();
            });
            this.scheduleOnce(()=>{
                this.showChoose(true);
            },.5);
        }else{
            this.scheduleOnce(()=>{
                this.showChoose(false);
            },.5);
        }
    }

    onMeComplete(){
        let chat = `红包：${this.currentPrice}`;
        this.onChat(chat,this.currentNpc);
    }

    showChoose(isEnd:boolean){
        let chooseAry = isEnd ? [this.endChat] : this.meOtherChats;
        this.currentChooseAry = chooseAry.concat();
        this.chooseNode.children.forEach((n:cc.Node,index:number)=>{
            let chooseStr = chooseAry[index];
            if(!chooseStr){
                n.active = false;
            }else{
                n.active = true;
                let nLabel = n.getChildByName("lb").getComponent(cc.Label);
                nLabel.string = chooseStr;
            }
        });
    }

    onBtnChoose(e:cc.Event.EventTouch,custom:string){
        let index = Number(custom);
        this.onChat(this.currentChooseAry[index],"自己");
        this.chooseNode.children.forEach((n:cc.Node)=>{
            n.active = false;
        });
    }

    showResult(){
        this.resultNode.active = true;
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onSell(){
        if(this.useRule){
            super.onBackPackOpenPrefab(this.useRule);
        }
        O1HD.getServices().userSrv.setCoins(this.price,true,this.node);
        this.complete && this.complete(true);
        this.closeThis();
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.complete && this.complete(false);
        this.closeThis();
    }
}
